import ReCAPTCHA from "react-google-recaptcha";
import react, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import ReCaptchaLogo from '../../../assets/icons/reCAPTCHA-logo@2x.png';
import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import ziLoader from "../../../assets/icons/black-loader-transperent.gif";

const PageLoaderContainer = styled.div`
  height: inherit;
  display: flex;
  align-items: center;
  margin: auto;
`;

const LoaderContainer = styled.div`
  margin: 0;
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -35%);
  width: 100%;
  height: 100%;
  .zoomloader {
    z-index: 100;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    .zoomloaderImg {
      background: url(${ziLoader}) no-repeat center center;
      background-size: contain;
      margin: auto;
      max-width: 100px;
      max-height: 100px;
      height: 100%;
      width: 100%;
    }
  }
`;


const ReCaptchaForm = styled.form`
`;

const RecaptchaContainer = styled.div`
  position: relative;
  width: 320px;
  visibility: hidden;
  display: flex;
  padding: 10px 20px 10px 10px;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #efefef;
  border-radius: 12px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
`

const NotARobotText = styled.p`
  font-family: "Poppins";
  font-weight: 400;
  line-height: 22px;
  color: #525F76;
  display: flex;
  align-items: center;
  flex: 1;
  margin-right: 40px;
`;

const CheckBox = styled.input`
  width: 24px;
  height: 24px;
  margin-right: 20px;
`

const RecaptchaLogoImage = styled.img`
  width: 48px;
  height: 48px;
  justify-self: flex-end;
`


const ReCaptcha = ({setCaptchaToken}) => {
    const recaptchaRef = useRef();
    const [clicked, setClicked] = useState(false);

    const handleSubmit = async e => {
        e.preventDefault();
        const captchaToken = await recaptchaRef.current.executeAsync();
        recaptchaRef.current.reset();
        setCaptchaToken(captchaToken)
    }

    useEffect(async () => {
        const captchaToken = await recaptchaRef.current.executeAsync();
        recaptchaRef.current.reset();
        if(captchaToken) setCaptchaToken(captchaToken);
    }, [])

    return (
    <ReCaptchaForm>
      <RecaptchaContainer>
          {!clicked && <CheckBox type={'checkbox'} onChange={async e => {
              setClicked(true);
              await handleSubmit(e);
          }}/>}
          {clicked && <CircularProgress style={{marginLeft: "4px", marginRight: "20px", width: "24px", height: "24px"}}/>
          }
          <NotARobotText>I am not a robot</NotARobotText>
          <RecaptchaLogoImage src={ReCaptchaLogo}/>
      </RecaptchaContainer>
        <PageLoaderContainer  id="insent-page-loader-container">
            <LoaderContainer style={{ width: '50px', height: '50px', marginTop: '8%' }}>
                <div className="zoomloader">
                    <div className="zoomloaderImg" />
                </div>
            </LoaderContainer>
        </PageLoaderContainer>
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey="6LcZ6RohAAAAAD5JUaVIIn4vmgr09OcPaHMGGdM_"
          size="invisible"
        />
    </ReCaptchaForm>
    );
}

export default ReCaptcha;